<template>
    <div class="language-switcher">
        {{ $t('common.language') }}:
        <sui-dropdown
            placeholder="Gender"
            :options="options"
            v-model="current"
        />
    </div>
</template>

<script>
import { availableLangs, setLocale } from '@/i18n';

export default {
    data() {
        return {
            current: process.env.VUE_APP_I18N_DEFAULT,
            options: availableLangs.map(item => ({ 
                text: item, 
                value: item
            })),
        }
    },

    watch: {
        current: {
            handler(value) {
                setLocale(value);
                localStorage.setItem('app.lang', value);
            },
        }
    },

    created() {
        this.current = localStorage.getItem('app.lang') || process.env.VUE_APP_I18N_DEFAULT;
        setLocale(this.current);
    }
}
</script>

<style>
.language-switcher {
    color: #fff;
    padding: 20px 0;
    text-align: center;
}
</style>